import { Shield, Lock, CreditCard, Clock } from "lucide-react"
import { getEventSlugFromUrl, eventPath } from "@/lib/utils"

const TRUST_BADGES = [
  {
    icon: Shield,
    title: "Secure",
    subtitle: "SSL Protected",
    color: "rgb(179, 102, 255)",
    bg: "rgba(179, 102, 255, 0.12)",
  },
  {
    icon: Lock,
    title: "Safe Payment",
    subtitle: "PCI Compliant",
    color: "rgb(0, 200, 180)",
    bg: "rgba(0, 200, 180, 0.12)",
  },
  {
    icon: CreditCard,
    title: "Split Pay",
    subtitle: "Pay Together",
    color: "rgb(140, 100, 255)",
    bg: "rgba(140, 100, 255, 0.12)",
  },
  {
    icon: Clock,
    title: "Flexible",
    subtitle: "Free Changes",
    color: "var(--primary)",
    bg: "color-mix(in oklch, var(--primary) 12%, transparent)",
  },
]

export function Footer({ eventSlug }: { eventSlug?: string }) {
  const slug = eventSlug ?? getEventSlugFromUrl()
  return (
    <footer className="mt-20 border-t border-border">
      <div className="mx-auto max-w-7xl px-4 py-10">
        {/* Trust badges */}
        <div className="grid grid-cols-2 gap-4 @min-[64rem]:grid-cols-4">
          {TRUST_BADGES.map((badge) => (
            <div
              key={badge.title}
              className="flex items-center gap-3 rounded-xl bg-card/60 px-4 py-3"
            >
              <div
                className="flex size-9 shrink-0 items-center justify-center rounded-lg"
                style={{ background: badge.bg }}
              >
                <badge.icon className="size-4" style={{ color: badge.color }} />
              </div>
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-foreground">
                  {badge.title}
                </span>
                <span className="text-xs text-muted-foreground">
                  {badge.subtitle}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 @min-[40rem]:flex-row">
          <span className="text-sm text-muted-foreground">
            © 2026 Esports Travel. All rights reserved.
          </span>
          <div className="flex gap-6">
            <a
              href={eventPath(slug, "privacy")}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              Privacy
            </a>
            <a
              href={eventPath(slug, "terms")}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              Terms
            </a>
            <a
              href={eventPath(slug, "support")}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
